import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"white data-inline-content",attrs:{"fluid":""}},[_c('div',{staticClass:"qmkey-related-inline-table"},[_c(VDataTable,{staticClass:"qmkey-explorer-table-expansion-table",attrs:{"headers":_vm.columns,"items":_vm.current_qunit[_vm.props.attr],"item-key":"uid","dense":"","sort-by":"version","must-sort":"","sort-desc":""},scopedSlots:_vm._u([{key:"item.mimetype",fn:function(ref){
var item = ref.item;
return [_c(VIcon,{staticClass:"mr-2",attrs:{"small":"","color":_vm.getFileIcon(item.mimetype).color}},[_vm._v("\n          "+_vm._s(_vm.getFileIcon(item.mimetype).icon)+"\n        ")])]}},{key:"item.file_creation_date",fn:function(ref){
var item = ref.item;
return [(item.file_creation_date)?_c('span',[_vm._v("\n          "+_vm._s(new Date(item.file_creation_date).toLocaleDateString(undefined, {
              // weekday: 'long',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }))+"\n        ")]):_vm._e()]}},{key:"item.modification_date",fn:function(ref){
            var item = ref.item;
return [(item.modification_date)?_c('span',[_vm._v("\n          "+_vm._s(new Date(item.modification_date).toLocaleDateString(undefined, {
              // weekday: 'long',
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            }))+"\n        ")]):_vm._e()]}},{key:"item.actions",fn:function(ref){
            var item = ref.item;
return [_c('div',{staticClass:"actions-cont"},[_c(VBtn,{attrs:{"small":"","icon":"","disabled":!item.value,"color":"ctas darken-2"},on:{"click":function($event){return _vm.handleEvidence(item)}}},[_c(VIcon,{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(" mdi-download ")])],1),_c('ActionViewReports',{key:_vm.act,attrs:{"size":"small","unit":item,"loading":"false,","color":"ctas darken-2"},on:{"refresh":_vm.refresh_qunit,"clicked":_vm.clicked}})],1)]}}],null,true)})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }